/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StaticReportSectionGetById } from '../../models/static-report-section-get-by-id';

export interface ReportsControllerCreateStaticReportSection$Params {

/**
 * The name of the static report section for the content of the uploaded PDF file.
 */
  section: string;

/**
 * The language code of the static report section which is uploaded.
 */
  languageCode: 'cs' | 'de' | 'en' | 'es' | 'fr' | 'nl' | 'pl' | 'sk';

/**
 * The ID of the project to which the PDF file belongs. Optional ID of the project.
 *         The property is used only for PDF files strictly assigned to the project. For example, when we would need
 *         to upload a static PDF page for report, which will be used only in specific project.
 *         We can for example upload a custom user PDF that will be then placed on page wrapped by dynamic template,
 *         custom chart or any other data.
 */
  projectId?: string;

/**
 * The optional ID of the variant to which the PDF file belongs. Make sense only with
 *         projectId set as well. Defines a more specific PDF section which depends on the variant to which it is related.
 */
  variantId?: string;
  
    /**
     * Binary data of the static report section / PDF file to be uploaded. The maximum size is 1mb.
     */
    body: string
}

export function reportsControllerCreateStaticReportSection(http: HttpClient, rootUrl: string, params: ReportsControllerCreateStaticReportSection$Params, context?: HttpContext): Observable<StrictHttpResponse<StaticReportSectionGetById>> {
  const rb = new RequestBuilder(rootUrl, reportsControllerCreateStaticReportSection.PATH, 'post');
  if (params) {
    rb.query('section', params.section, {});
    rb.query('languageCode', params.languageCode, {});
    rb.query('projectId', params.projectId, {});
    rb.query('variantId', params.variantId, {});
    rb.body(params.body, 'application/pdf');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StaticReportSectionGetById>;
    })
  );
}

reportsControllerCreateStaticReportSection.PATH = '/planning-projects/v1/reports/static-report-sections';
